module.exports = __webpack_public_path__ + "static/media/goblin_swordman_head.8b28cd0e.svg";